module.exports = __webpack_public_path__ + "static/media/fullscreen_blue.7edb8c36.svg";